import axios from 'axios';

const apiUrl = process.env.CA_IF_API_URL || '[Env var not set: CA_IF_API_URL]';

axios.defaults.withCredentials = true;


export const post = async (resource, data, responseType) => {

  let axiosConstuct = {
    method: 'post',
    url: apiUrl + resource,
    data: data,
    withCredentials: true
  };
  
  if (typeof responseType !== 'undefined') {
    axiosConstuct['responseType'] = responseType;
  }
  
  try {
    const req = await axios(axiosConstuct);

    return req;
  }
  catch ( error ) {
    throw error;
  }
}

